<template>
  <div v-if="isValidCountry" class="h-100 w-100">
    <img
      :src="imgSource"
      alt="offer"
      class="w-100 h-100"
      @click="offerRedirect"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType } from "vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";

enum Country {
  MX = "MX",
  EC = "EC",
  PA = "PA",
  PE = "PE",
  CO = "CO",
  ZA = "ZA",
  BR = "BR",
  PH = "PH",
  ID = "ID",
}

const props = defineProps({
  country: String as PropType<Country>,
});

const isValidCountry = computed(() => {
  if (!props.country) return false;
  return Object.values(Country).includes(props.country);
});

const imgSource = computed(() => {
  return useAsset(
    `img/non-eligible-offer/phonefinance_priorborrower_promo_${props.country}.webp`
  );
});

const offerRedirect = () => {
  if (props.country === Country.PH) {
    window.location.href = "https://www.payjoy.com/ph/phone-finance/";
  } else {
    window.location.href = `https://payjoy.me/${props.country}${
      props.country === Country.EC ? "pf" : "app"
    }`;
  }
};
</script>

<style lang="scss" scoped></style>
